import { InformationRequestAction } from "../../../domain/InformationRequestAction";

export enum DialogActionType {
  CreateAction,
  CreateActionUploadDocuments,
  CreateActionRespondWithDocuments,

  EditAction,
  ViewAction,
  RespondToMessage,
  RespondWithDocuments,
  DownloadDocument,
  DeleteAction,
}

export type DialogActionTypeWithAction = {
  dialogActionType: DialogActionType;
  action?: InformationRequestAction;
};

export type DialogActionArgument = null | DialogActionType | DialogActionTypeWithAction;
